export default function FixedHeaders(){
  return {
    restrict: "A",
    link: function(scope, element, attr){

      var $table = element.find(".body table");
      var $top = element.find(".top");
      var $left = element.find(".left");
      var $body  = element.find(".body");

      var updateHeaders = function(){
        var rows = $table.find("tr");
        var rowheights = Array.prototype.map.call(rows,row => row.getBoundingClientRect().height);
        $left.find("div").each((i, el) => {
          el.style.height = rowheights[i]+"px";
        });
        var cols = $table.find("tr:first-child td");
        var colwidths = Array.prototype.map.call(cols,col => col.getBoundingClientRect().width);
        $top.find("div").each((i,el) => el.style.width = colwidths[i]+"px");        
        $top[0].scrollLeft=$body[0].scrollLeft;
        $left[0].scrollTop=$body[0].scrollTop;
      }
      $body.on("scroll", updateHeaders);

      var observer = new MutationObserver(updateHeaders);
      observer.observe(element[0], {
          childList: true,
          subtree: true
      });
    }    
  }
}


// WEBPACK FOOTER //
// ./src/fixed-headers/FixedHeaders.js